export { default as SalidaProductos } from "./SalidaProductosContainer";
